// extracted by mini-css-extract-plugin
var _1 = "pIOXw";
export { _1 as "base" }
